const NICKNAMES = [
  'Aspirin',
  'Paper Cut',
  'Boyfriend',
  'Ketchup',
  'Diarrhea',
  'Shlup',
  'Slop',
  'Nausea',
  'Starbucks',
  'Meatball',
  'Rest',
  'Zzzz',
  'Bread',
  'Holdthedoor',
  'Hodor',
  'RonWeavly',
  'Vabroeon',
  'Rick',
  'Brick Rat',
  'Fastpoke',
  'Slowsis',
  'Patrick',
  'Cue-Ball',
  'Jack Spearow',
  'Geobabe',
  'Doofus',
  'Timmy',
  'Barbecue',
  'Emo',
  'Digimon',
  'Agumon',
  'Reginald',
  'BodyIsRegi',
  'Wazowski',
  'R2-D2',
  'Subway',
  'FeedMeNow',
  'Automate',
  'Earphones',
  'Webcam',
  'Cliché',
  'Splash',
  'Useless',
  'A Flop',
  'Mariokarp',
  'Kakunamatata',
  'Onixpected',
  'West Side',
  'East Side',
  'Vulgar',
  'FlygonJinn',
  'M.S.surf',
  'Tree Stooges',
  'NutCase',
  'Chuck Norris',
  'Shuck Norris',
  'El Mariachi',
  'Swine Flu',
  'Bird Flu',
  'Windows 95',
  'Oh no! It',
  'Confused',
  'Vodka',
  'Moonshine',
  'Saki',
  'NameRater',
  'KFC',
  'Hentai',
  'Revive',
  'Teleport',
  'Finally!',
  'YAASS!',
  'Share',
  'Fainted',
  'Thugtrio',
  'Quesadilla',
  'Margarine',
  'Panick',
  'Help',
  'Rainbow',
  'Colors',
  'Anastasia',
  'Glitter',
  'Heidi',
  'Mooch',
  'TLC',
  'Mama',
  'Loyal',
  'Rosie',
  'Coco',
  'Crumbs',
  'Snacks',
  'Nimbles',
  'Ruffles',
  'Ruffian',
  'Grumpy Cat',
  'Tipsy',
  'Tickles',
  'Swift',
  'Aphrodite',
  'Mischief',
  'Flutters',
  'Epona',
  'Buttercup',
  'Tabby',
  'Tilly',
  'Ittybitty',
  'Lily',
  'Lalo',
  'Cerise',
  'May',
  'April',
  'June',
  'July',
  'Gemini',
  'Aires',
  'Libra',
  'Virgo',
  'Aquarius',
  'Dorothy',
  'Clarica',
  'Marbles',
  'Hugs',
  'Cuddles',
  'Companion',
  'Olive',
  'Kisses',
  'Attract',
  'Charm',
  'Charming',
  'Handsome',
  'Elegant',
  'Pooch',
  'Poochy',
  'Squirt',
  'Flirt',
  'Hope',
  'Faith',
  'Rhapsody',
  'Symphony',
  'Serenade',
  'Anthem',
  'Melody',
  'Harmony',
  'Harmonia',
  'Stardust',
  'Snappy',
  'Teeth',
  'Noodles',
  'Teddy',
  'McNugget',
  'Tranquil',
  'ScrappyDoo',
  'Whiskers',
  'Ralph',
  'Tori',
  'Misty',
  'Unicorn',
  'Careless',
  'PikaPika',
  'Pwichu',
  'Tiny',
  'Teeny',
  'Tinsy',
  'Jellybelly',
  'Jellybean',
  'Barbie',
  'Eeveelution',
  'Pup',
  'BestFriend',
  'Strawberries',
  'Kiwi',
  'Avocado',
  'Pesto',
  'Chives',
  'Shortcake',
  'Havoc',
  'Shield',
  'Viking',
  'Odin',
  'Valkyrie',
  'Pride',
  'Templar',
  'Rogue',
  'Al Capone',
  'Warlord',
  'Warmaiden',
  'Dagger',
  'Blades',
  'Thrasher',
  'Brigadier',
  'Teutonic',
  'Rex',
  'Boss',
  'Chief',
  'Augustus',
  'Octavian',
  'Nero',
  'Paladin',
  'Behemoth',
  'Viscount',
  'Cicero',
  'Picasso',
  'Highlander',
  'Romulus',
  'Xerxes',
  'Caesar',
  'Goliath',
  'Cyclops',
  'Scar',
  'Mufasa',
  'Archer',
  'Excalibur',
  'Swordsman',
  'Katana',
  'Rambo',
  'Blitz',
  'Noisemaker',
  'Prince',
  'Boudicca',
  'Pericles',
  'Raider',
  'Balthazar',
  'Lancer',
  'Spartan',
  'Stag',
  'Baron',
  'Gryphon',
  'Aurelius',
  'Hadrian',
  'Cleopatra',
  'Pharaoh',
  'Menthu',
  'Emperor',
  'Empress',
  'Sultan',
  'Tsar',
  'Tiberius',
  'Trojan',
  'Shiva',
  'Ninja',
  'Godzilla',
  'King Kong',
  'Cyan',
  'Barbarian',
  'Seigi',
  'Mafia',
  'Kronos',
  'Peeps',
  'Kanto',
  'Johto',
  'Hoenn',
  'Sinnoh',
  'Unova',
  'Kalos',
  'Alola',
  'Orre',
  'Fiore',
  'Almia',
  'Ransei',
  'Oblivia',
  'Predator',
  'Kraken',
  'Cannon',
  'Nightmare',
  'Slayer',
  'Diesel',
  'Benzene',
  'Petrol',
  'Charred',
  'Charcoal',
  'Coal',
  'Face Melter',
  'Ignis',
  'Under Fire',
  'SpitFire',
  'Friction',
  'Fire Starter',
  'Blaze',
  'Raze',
  'Infernos',
  'Immolata',
  'Cinder',
  'Hephaestus',
  'Molten',
  'Magma',
  'Lava',
  'LiquidRock',
  'Volcano',
  'Yellowstone',
  'WildFire',
  'FireStorm',
  'MeltingPoint',
  'Meltdown',
  'Torch',
  'Burnt',
  'Pyro',
  'Pyroclastic',
  'FlashBang',
  'Butane',
  'Propane',
  'Sunburnt',
  'Solar Flare',
  'Fireball',
  'Gun Smoke',
  'Smolder',
  'Zippo',
  'TheHeat',
  'FlameOn',
  'FlameThrower',
  'Third-Degree',
  'Harbour',
  'Admiral',
  'Tsunami',
  'Baywatch',
  'Coral',
  'CoralReef',
  'BarrierReef',
  'Atlantis',
  'Aquaman',
  'Aquamarine',
  'Squid',
  'Squidward',
  'Seaweed',
  'Rain Man',
  'McBoatface',
  'Tidalia',
  'Anchor',
  'Squall',
  'Krabby',
  'FishSticks',
  'Neptune',
  'Poseidon',
  'Calypso',
  'Hydro',
  'Waves',
  'Bubbles',
  'Puddles',
  'Tugboat',
  'Pearl',
  'Crest',
  'Jet',
  'Drizzle',
  'Ocean',
  'Lake Monster',
  'Torrent',
  'The Navy',
  'ChumBucket',
  'FishSalad',
  'Sushi',
  'MyBeach',
  'Waterfall',
  'Captain',
  'Treehugger',
  'Splinters',
  'Roots',
  'Congo',
  'Great Deku',
  'Cactus',
  'Canopy',
  'Garlic',
  'Starch',
  'AllSpice',
  'Verde',
  'Sticks',
  'Bamboo',
  'Pinocchio',
  'Aja',
  'Acorn',
  'Vegetable',
  'Onion',
  'Beans',
  'Carrot',
  'Potatoe',
  'Amazon',
  'Ent',
  'Treebeard',
  'Flore',
  'Shamrock',
  'Arduinna',
  'Buckwheat',
  'Ceres',
  'Melon',
  'Bonsai',
  'Tropics',
  'Blossom',
  'Corny',
  'Cornbread',
  'Rosemary',
  'Thyme',
  'Willow',
  'Autumn',
  'Spring',
  'Sultana',
  'Weed',
  'Swampy',
  'Fruitful',
  'Fruity',
  'Moss',
  'Mold',
  'Average',
  'Simon',
  'Whitney',
  'Lenora',
  'Cheren',
  'Norman',
  'Bates',
  'Normandy',
  'Rodent',
  'Feline',
  'Catty',
  'Canada',
  'Switzerland',
  'Neutral',
  'Neuter',
  'Doglike',
  'Dogo',
  'K9',
  'Mammal',
  'Winnie',
  'Pooh',
  'PoohBear',
  'Fang',
  'Jaws',
  'Claws',
  'Rings',
  'Proxy',
  'Antidote',
  'Tackle',
  'Struggle',
  'Basic',
  'Pet',
  'Felix',
  'Sonic',
  'Tales',
  'Substitute',
  'Fake Out',
  'Motherboard',
  'Conductor',
  'Ballistic',
  'ShortCircuit',
  'Tesla',
  'Edison',
  'Thor',
  'Mjolnir',
  'Rudra',
  'Raygun',
  'Zeus',
  'Narukami',
  'Rijin',
  'Gizmo',
  'Buzz',
  'Volts',
  'Amps',
  'Machine',
  'Computer',
  'Photon',
  'Raiden',
  'Zap',
  'Zapper',
  'Stormcloud',
  'Supercharged',
  'Taser',
  'Ion',
  'Electric',
  'Gadget',
  'X-Ray',
  'Boomer',
  'Sparks',
  'Sparky',
  'Sparkplug',
  'Shocked',
  'Shock Wave',
  'Static',
  'Hazard',
  'Gigabyte',
  'Megabyte',
  'Terabyte',
  'Bolt',
  'DangerDanger',
  'Sizzle',
  'Quark',
  'Luddite',
  'Radar',
  'Energy',
  'Synergy',
  'Android',
  'Carbon',
  'Carbonite',
  'Malphite',
  'Flint',
  'Obsidian',
  'Hard Rock',
  'Granite',
  'Pyrite',
  'Brick',
  'Blockhead',
  'Caveman',
  'CaveMonster',
  'Boulder',
  'Scoria',
  'Jagged',
  'Cliff',
  'Malachite',
  'Shale',
  'Stone',
  'Stoned',
  'Stonewall',
  'StoneHeart',
  'Rosetta',
  'Rock Dagger',
  'Rocco',
  'Rocky IX',
  'Rocky Balboa',
  'Rock',
  'TheRock',
  'RockStar',
  'RockNRoll',
  'Brock',
  'Lapis',
  'Canyon',
  'Valley',
  'Keystone',
  'Asphalt',
  'Slate',
  'Rockbottom',
  'Edge',
  'RoughEdge',
  'SharpEdge',
  'Stalagmite',
  'Stalactite',
  'Speleothem',
  'Limestone',
  'Roxy',
  'Wrecker',
  'Petrify',
  'Larva',
  'Junebug',
  'LadyBug',
  'Mantis',
  'Netwing',
  'Nit',
  'Tick',
  'Aristaeus',
  'Bumble',
  'Flik',
  'Stink Bug',
  'Pest',
  'Bugsy',
  'Swarm',
  'Arachnid',
  'Arthropod',
  'Tarantula',
  'Love Bug',
  'Buggin’ You',
  'Buggles',
  'Weevil',
  'Locust',
  'Tithonus',
  'Jiminy',
  'Beetlejuice',
  'Mudbug',
  'Queen Bee',
  'Bugzilla',
  'Scarab',
  'Mosquito',
  'Hive',
  'BugDealer',
  'Splat',
  'FireFly',
  'SoftwareBug',
  'Mothman',
  'WebSpinner',
  'Spiderman',
  'HuntsMan',
  'EightLegs',
  '8LeggedFreak',
  'WebSurfer',
  'Shelob',
  'Ungoliant',
  'Aragog',
  'Acromantula',
  'Melee',
  'Bam-Bam',
  'Bruiser',
  'O.',
  'Stunner',
  'Bully',
  'Throttle',
  'Brawler',
  'Sparta',
  'Tyson',
  'Tatum',
  'Balboa',
  'Champ',
  'Brute',
  'Brutus',
  'T',
  'Wick',
  'Crews',
  'DropKick',
  'Fists',
  'FistPump',
  'BlackNBlue',
  'Blisters',
  'Karate Kid',
  'Sensei',
  'Muscles',
  'Ox',
  'StreetFight',
  'Ryu',
  'Hercules',
  'Hercule',
  'Goku',
  'Super Saiyan',
  'Hulk',
  'Bruno',
  'Bruce',
  'Sumo',
  'PorkChop',
  'Spar',
  'Roadhouse',
  'Aerial',
  'Ajax',
  'Grythin',
  'Bird Brain',
  'Vortex',
  'Kestrel',
  'Zenith',
  'Ozone',
  'Jet Stream',
  'Stratosphere',
  'Stratus',
  'Zazu',
  'Downdraft',
  'Concorde',
  'Hurricane',
  'Cyclone',
  'Hawking',
  'Hawk-Eye',
  'Eagle-Eye',
  'Raven',
  'Aileron',
  'Skyburst',
  'Falcon',
  'Peregrine',
  'Rooster',
  'Vulture',
  'SundayRoast',
  'Airfreak',
  'Icarus',
  'Wind',
  'Skyraider',
  'Gilder',
  'Phoenix',
  'Leatherwing',
  'Nimbus',
  'Cloud9',
  'Zephyr',
  'Wings',
  'Quail',
  'Tomahawk',
  'Airy',
  'Adolphe',
  'Brainwash',
  'Enigma',
  'Einstein',
  'Rasputin',
  'Enkefalos',
  'Third Eye',
  'Karma',
  'Mindbreaker',
  'Mindbender',
  'Spoonbender',
  'TwoSpoons',
  'Vulcan',
  'Holmes',
  'Merlin',
  'Psychosis',
  'Clairvoyant',
  'Nostradamus',
  'Professor',
  'Ego',
  'Super Ego',
  'Id',
  'Genius',
  'Eureka',
  'Darwin',
  'Zen',
  'Cerebellum',
  'Cerebella',
  'Cerebro',
  'Cerefella',
  'Tarot',
  'Oracle',
  'Mana',
  'Savvy',
  'Houdini',
  'Mirage',
  'Paradox',
  'Pandora',
  'JeanGrey',
  'Xavier',
  'Telekinetic',
  'LSD',
  'Hiro',
  'Bamboozled',
  'Nocturnal',
  'Sith Lord',
  'Darth Vader',
  'Medusa',
  'Luna',
  'Lunes',
  'Chaos',
  'Cthulhu',
  'Hades',
  'Styx',
  'Loki',
  'Cerberus',
  'Arcane',
  'Harpy',
  'Wendigo',
  'Nemesis',
  'Voodoo',
  'Soulless',
  'Soul Crusher',
  'Soul Taker',
  'Soul Eater',
  'Dante',
  'Tyrant',
  'Rougarou',
  'Evil Doer',
  'Cursed',
  'Depraved',
  'Demoralized',
  'Fiend',
  'Corruption',
  'Krampus',
  'Slender Man',
  'Crossbones',
  'Jealousy',
  'Pagan',
  'Druid',
  'Hex',
  'Lurker',
  'Sacrificial',
  'Witchdoctor',
  'Dracula',
  'Gorgon',
  'Demonic',
  'Void',
  'Hannibal',
  'NightHunter',
  'Bones',
  'TheGoth',
  'Aurora',
  'Avalanche',
  'Blizzard',
  'Mammoth',
  'Frost',
  'Frozen',
  'Frosty',
  'Frieza',
  'Coldwater',
  'Flurry',
  'Slush',
  'Sleet',
  'Snow',
  'Snowy',
  'Snowman',
  'Tundra',
  'Arctic',
  'Antarctic',
  'Himalaya',
  'Everest',
  'K2',
  'Atlas',
  'Alps',
  'Glacier',
  'Glacicles',
  'Dry Ice',
  'Icicle',
  'Iceman',
  'Ice King',
  'Ice Queen',
  'Ice Pick',
  'Ice Cube',
  'Ice Cold',
  'Ice Fang',
  'Titanic',
  'Iceberg',
  'BigBergtha',
  'Winter',
  'Yukon',
  'Alaska',
  'Permafrost',
  'Hail',
  'Ice Beam',
  'Pingu',
  'Hibernator',
  'Istas',
  'Dirt',
  'Gravel',
  'Mud',
  'Muddy',
  'MudBug',
  'MudHen',
  'Glebe',
  'Sod',
  'Soil',
  'Terra',
  'Terracotta',
  'Terra Firma',
  'Terrain',
  'Spud',
  'Quarry',
  'Compost',
  'Rumble',
  'Earthquake',
  'Quake',
  'Tremors',
  'Seismic',
  'Landscape',
  'Alluvium',
  'Sand',
  'Sandy',
  'Quicksand',
  'Sandman',
  'Desert',
  'Loam',
  'Bedrock',
  'Crust',
  'Landformer',
  'Landmover',
  'Fault Line',
  'Diggit',
  'Rubble',
  'Clay',
  'Sediment',
  'Humus',
  'Dusty',
  'Earth',
  'Earthling',
  'Continent',
  'Turf',
  'Solid',
  'Soot',
  'Gaia',
  'Fossil',
  'Perfume',
  'Leper',
  'Venom',
  'Venin',
  'Ivy',
  'Rotten',
  'Stench',
  'Contagion',
  'Contagious',
  'Infected',
  'Infectus',
  'Infection',
  'Virus',
  'Toxin',
  'Toxoid',
  'Toxicant',
  'Contaminant',
  'Acidic',
  'Pollution',
  'Plague',
  'Disease',
  'Fungi',
  'FunGuy',
  'Fumigate',
  'Parasite',
  'Bacteria',
  'Bane',
  'Germs',
  'Miasma',
  'Carcinogen',
  'Tetrodotoxin',
  'Strychnine',
  'Sarin',
  'Polonium',
  'Ricin',
  'VX',
  'Botulinum',
  'DartFrog',
  'FrogLicker',
  'NoCure',
  'Irukandji',
  'Malo Kingi',
  'Tetanus',
  'Tank',
  'Crank',
  'Clank',
  'Magnet',
  'HeavyMetal',
  'Crowbar',
  'Wrench',
  'Adamantium',
  'Titanium',
  'Aluminum',
  'Alloy',
  'Klaxon',
  'Lugnut',
  'Piston',
  'Ratchet',
  'Rusty',
  'Weld',
  'Magneto',
  'Colossus',
  'Platinum',
  'FreightTrain',
  'Ingot',
  'Buzzsaw',
  'Tungsten',
  'Iron',
  'Ironside',
  'CannonBall',
  'Sterling',
  'Silver',
  'Uranium',
  'Salvage',
  'BrassKnuckle',
  'QuickSilver',
  'Mercury',
  'Razor',
  'Drillbit',
  'Copper',
  'Chassis',
  'Bullet',
  'Chime',
  'Chrome',
  'Chromium',
  'Steely',
  'Knight',
  'Gunmetal',
  'Tinman',
  'Stainless',
  'Manganese',
  'Vanish',
  'Eidolon',
  'Sixth Sense',
  'Misfortune',
  'Banshee',
  'Slimer',
  'Occult',
  'Visitor',
  'Conjuring',
  'Ignis Fatuus',
  'Tombstone',
  'Shadow',
  'Shade',
  'X-Files',
  'Sorrow',
  'Eerie',
  'Medium',
  'Trance',
  'GhostEye',
  'Specter',
  'Poltergeist',
  'Kelpie',
  'Wraith',
  'Chicanery',
  'Calamity',
  'Sepulcher',
  'Boogeyman',
  'Phantom',
  'Phantasm',
  'Shivers',
  'Revenant',
  'Ethereal',
  'Aura',
  'Casper',
  'Diabolic',
  'The Undead',
  'Possessed',
  'Avenged',
  'Ghoul',
  'Misery',
  'Zombie',
  'Apparition',
  'Fringe',
  'Angel',
  'Enchanter',
  'Leprechaun',
  'Navi',
  'TimeFairy',
  'Goblin',
  'Gremlin',
  'Oberon',
  'Sylph',
  'Cherub',
  'Fairycakes',
  'Fay',
  'Nisse',
  'Robin',
  'Puck',
  'Celestial',
  'Gnome',
  'Artemis',
  'Cupid',
  'Divine',
  'Sprinkle',
  'Dixie',
  'Impalpable',
  'Siren',
  'Fayette',
  'Tam Lin',
  'Imp',
  'Sympathy',
  'YinYang',
  'Spirit',
  'Kindred',
  'Aos Si',
  'LuckyCharm',
  'Athena',
  'Genie',
  'Fairytale',
  'Empyrean',
  'Mystical',
  'Mystic',
  'Mystique',
  'Zelda',
  'Princess',
  'Peach',
  'Daisy',
  'Rapunzel',
  'ToothFairy',
  'Yōsei',
  'Wyvern',
  'Spyro',
  'Puff',
  'Jabberwock',
  'DragonBall',
  'Shenron',
  'Porunga',
  'Smaug',
  'Fafnir',
  'Mizuchi',
  'Ryujin',
  'Norbert',
  'Tarasque',
  'Dragunov',
  'Dragoon',
  'Drogon',
  'Rhaegal',
  'Viserion',
  'DragonStone',
  'Scales',
  'Mushu',
  'Toothless',
  'Alduin',
  'Drag Queen',
  'Dragon Queen',
  'Draco',
  'ZmeyGorynych',
  'Ladon',
  'Hydra',
  'Typhon',
  'Typhoeus',
  'Kaiju',
  'Reptilian',
  'Bowser',
  'King Koopa',
  'Yoshi',
  'Natsu',
  'Salamander',
  'Komodo',
  'DragonHeart',
  'Serpent',
  'LochNess',
  'Nessy',
  'George',
  'Gawain',
];

export default NICKNAMES;
